import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  tr: { name: '🇹🇷 Türkçe', flag: '🇹🇷' },
  en: { name: '🇬🇧 English', flag: '🇬🇧' },
  de: { name: '🇩🇪 Deutsch', flag: '🇩🇪' },
  fr: { name: '🇫🇷 Français', flag: '🇫🇷' },
  es: { name: '🇪🇸 Español', flag: '🇪🇸' },
  it: { name: '🇮🇹 Italiano', flag: '🇮🇹' },
  pt: { name: '🇵🇹 Português', flag: '🇵🇹' },
  pl: { name: '🇵🇱 Polski', flag: '🇵🇱' },
  nl: { name: '🇳🇱 Nederlands', flag: '🇳🇱' },
  ru: { name: '🇷🇺 Русский', flag: '🇷🇺' }
};

export const TRANSLATIONS = {
  tr: {
      login: {
        title: 'Hoş geldiniz',
        subtitle: 'Hesabınıza giriş yapın',
        email: 'E-posta Adresi',
        password: 'Şifre',
        forgotPassword: 'Şifremi unuttum',
        loginBtn: 'Giriş Yap →',
        loggingIn: 'Giriş yapılıyor...',
        testAccount: 'Test Hesabı (Çiftçi)',
        terms: 'Kullanım Şartları',
        privacy: 'Gizlilik Politikası',
        termsAccept: 'kabul etmiş olursunuz.',
        tryTestAccount: 'Test hesabı ile dene',
        farm: 'Çiftliğinizi akıllıca yönetin',
        description: 'Hayvan sağlığı, üretim takibi, finansal raporlar ve çok daha fazlası — hepsi tek platformda.',
        invalidCredentials: 'E-posta veya şifre hatalı',
        connectionError: 'Bağlantı hatası. Sunucu çalışıyor mu?',
        resetEmailSent: 'Şifre sıfırlama bağlantısı',
        emailSentTo: 'adresine gönderildi.',
        close: 'Kapat',
        sending: 'Gönderiliyor...',
        sendResetLink: 'Sıfırlama Bağlantısı Gönder',
        checkSpam: 'Gelen kutunuzu kontrol edin. Spam klasörünü de unutmayın!',
        checkEmail: 'E-postanızı kontrol edin',
        enterEmail: 'Şifrenizi sıfırlamak için e-posta adresinizi girin',
        resetLinkSent: 'Şifre sıfırlama bağlantısı e-posta adresinize gönderildi',
        features: [
          'Hayvan pasaport ve soy takibi',
          'Sağlık kayıtları ve aşı takibi',
          'Gerçek zamanlı üretim raporları',
          'Mobil uygulama desteği'
        ],
        stats: [
          { num: '2.500+', label: 'Aktif Çiftçi' },
          { num: '180K+', label: 'Kayıtlı Hayvan' },
          { num: '%98', label: 'Memnuniyet' }
        ]
      }
  },
  en: {
    login: {
      title: 'Welcome back',
      subtitle: 'Sign in to your account',
      email: 'Email Address',
      password: 'Password',
      forgotPassword: 'Forgot password',
      loginBtn: 'Sign In →',
      loggingIn: 'Signing in...',
      testAccount: 'Test Account (Farmer)',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      termsAccept: 'agree to the.',
      tryTestAccount: 'Try with test account',
      farm: 'Manage your farm intelligently',
      description: 'Animal health, production tracking, financial reports and much more — all in one platform.',
      features: [
        'Animal passport and pedigree tracking',
        'Health records and vaccination tracking',
        'Real-time production reports',
        'Mobile app support'
      ],
      stats: [
        { num: '2,500+', label: 'Active Farmers' },
        { num: '180K+', label: 'Registered Animals' },
        { num: '%98', label: 'Satisfaction' }
      ]
    }
  },
  de: {
    login: {
      title: 'Willkommen zurück',
      subtitle: 'Melden Sie sich bei Ihrem Konto an',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen',
      loginBtn: 'Anmelden →',
      loggingIn: 'Wird angemeldet...',
      testAccount: 'Testkonto (Bauer)',
      terms: 'Nutzungsbedingungen',
      privacy: 'Datenschutzrichtlinie',
      termsAccept: 'stimmen dem zu.',
      tryTestAccount: 'Mit Testkonto versuchen',
      farm: 'Verwalten Sie Ihre Farm intelligent',
      description: 'Tiergesundheit, Produktionsverfolgung, Finanzberichte und vieles mehr — alles auf einer Plattform.',
      features: [
        'Tierhaltpass und Stammbaum-Verfolgung',
        'Gesundheitsakten und Impfstoff-Verfolgung',
        'Echtzeitproduktionsberichte',
        'Mobile-App-Unterstützung'
      ],
      stats: [
        { num: '2.500+', label: 'Aktive Bauern' },
        { num: '180K+', label: 'Registrierte Tiere' },
        { num: '%98', label: 'Zufriedenheit' }
      ]
    }
  },
  fr: {
    login: {
      title: 'Bienvenue',
      subtitle: 'Connectez-vous à votre compte',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié',
      loginBtn: 'Se connecter →',
      loggingIn: 'Connexion en cours...',
      testAccount: 'Compte de test (Agriculteur)',
      terms: 'Conditions d\'utilisation',
      privacy: 'Politique de confidentialité',
      termsAccept: 'acceptez le.',
      tryTestAccount: 'Essayer avec le compte de test',
      farm: 'Gérez votre ferme intelligemment',
      description: 'Santé animale, suivi de la production, rapports financiers et bien plus — tout en une seule plateforme.',
      features: [
        'Suivi du passeport animal et de la généalogie',
        'Dossiers de santé et suivi des vaccins',
        'Rapports de production en temps réel',
        'Support des applications mobiles'
      ],
      stats: [
        { num: '2 500+', label: 'Agriculteurs actifs' },
        { num: '180K+', label: 'Animaux enregistrés' },
        { num: '%98', label: 'Satisfaction' }
      ]
    }
  },
  es: {
    login: {
      title: 'Bienvenido',
      subtitle: 'Inicia sesión en tu cuenta',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: 'Olvidé mi contraseña',
      loginBtn: 'Iniciar sesión →',
      loggingIn: 'Iniciando sesión...',
      testAccount: 'Cuenta de prueba (Granjero)',
      terms: 'Términos de servicio',
      privacy: 'Política de privacidad',
      termsAccept: 'aceptas el.',
      tryTestAccount: 'Probar con cuenta de prueba',
      farm: 'Gestiona tu granja de forma inteligente',
      description: 'Salud animal, seguimiento de producción, informes financieros y mucho más — todo en una plataforma.',
      features: [
        'Seguimiento de pasaporte animal y pedigrí',
        'Registros de salud y seguimiento de vacunación',
        'Informes de producción en tiempo real',
        'Soporte de aplicación móvil'
      ],
      stats: [
        { num: '2.500+', label: 'Granjeros activos' },
        { num: '180K+', label: 'Animales registrados' },
        { num: '%98', label: 'Satisfacción' }
      ]
    }
  },
  it: {
    login: {
      title: 'Bentornato',
      subtitle: 'Accedi al tuo account',
      email: 'Indirizzo email',
      password: 'Password',
      forgotPassword: 'Password dimenticata',
      loginBtn: 'Accedi →',
      loggingIn: 'Accesso in corso...',
      testAccount: 'Account di prova (Agricoltore)',
      terms: 'Termini di servizio',
      privacy: 'Politica sulla privacy',
      termsAccept: 'accetti il.',
      tryTestAccount: 'Prova con account di prova',
      farm: 'Gestisci la tua fattoria intelligentemente',
      description: 'Salute animale, tracciamento della produzione, rapporti finanziari e molto altro — tutto in una piattaforma.',
      features: [
        'Tracciamento del passaporto animale e della genealogia',
        'Registri sanitari e tracciamento delle vaccinazioni',
        'Rapporti di produzione in tempo reale',
        'Supporto dell\'app mobile'
      ],
      stats: [
        { num: '2.500+', label: 'Agricoltori attivi' },
        { num: '180K+', label: 'Animali registrati' },
        { num: '%98', label: 'Soddisfazione' }
      ]
    }
  },
  pt: {
    login: {
      title: 'Bem-vindo de volta',
      subtitle: 'Faça login em sua conta',
      email: 'Endereço de e-mail',
      password: 'Senha',
      forgotPassword: 'Esqueci minha senha',
      loginBtn: 'Fazer login →',
      loggingIn: 'Fazendo login...',
      testAccount: 'Conta de teste (Agricultor)',
      terms: 'Termos de serviço',
      privacy: 'Política de privacidade',
      termsAccept: 'você concorda com o.',
      tryTestAccount: 'Tentar com conta de teste',
      farm: 'Gerencie sua fazenda de forma inteligente',
      description: 'Saúde animal, rastreamento de produção, relatórios financeiros e muito mais — tudo em uma plataforma.',
      features: [
        'Rastreamento de passaporte animal e pedigree',
        'Registros de saúde e rastreamento de vacinação',
        'Relatórios de produção em tempo real',
        'Suporte ao aplicativo móvel'
      ],
      stats: [
        { num: '2.500+', label: 'Agricultores ativos' },
        { num: '180K+', label: 'Animais registrados' },
        { num: '%98', label: 'Satisfação' }
      ]
    }
  },
  pl: {
    login: {
      title: 'Witaj ponownie',
      subtitle: 'Zaloguj się do swojego konta',
      email: 'Adres e-mail',
      password: 'Hasło',
      forgotPassword: 'Zapomniałem hasła',
      loginBtn: 'Zaloguj się →',
      loggingIn: 'Logowanie...',
      testAccount: 'Konto testowe (Rolnik)',
      terms: 'Warunki usługi',
      privacy: 'Polityka prywatności',
      termsAccept: 'akceptujesz.',
      tryTestAccount: 'Spróbuj z kontem testowym',
      farm: 'Zarządzaj swoją farmą inteligentnie',
      description: 'Zdrowie zwierząt, śledzenie produkcji, raporty finansowe i wiele więcej — wszystko na jednej platformie.',
      features: [
        'Śledzenie paszportu zwierzęcia i genealogii',
        'Rejestry zdrowia i śledzenie szczepień',
        'Raporty produkcji w czasie rzeczywistym',
        'Obsługa aplikacji mobilnej'
      ],
      stats: [
        { num: '2.500+', label: 'Aktywni rolnicy' },
        { num: '180K+', label: 'Zarejestrowane zwierzęta' },
        { num: '%98', label: 'Zadowolenie' }
      ]
    }
  },
  nl: {
    login: {
      title: 'Welkom terug',
      subtitle: 'Meld je aan bij je account',
      email: 'E-mailadres',
      password: 'Wachtwoord',
      forgotPassword: 'Wachtwoord vergeten',
      loginBtn: 'Inloggen →',
      loggingIn: 'Inloggen...',
      testAccount: 'Testaccount (Boer)',
      terms: 'Servicevoorwaarden',
      privacy: 'Privacybeleid',
      termsAccept: 'je accepteert het.',
      tryTestAccount: 'Probeer met testaccount',
      farm: 'Beheer je boerderij intelligent',
      description: 'Dierengezondheidheid, productietracking, financiële rapporten en veel meer — alles op één platform.',
      features: [
        'Tracking van dierenpaspoort en stamboom',
        'Gezondheidsregisters en vaccinatietracking',
        'Real-time productierapporten',
        'Ondersteuning voor mobiele app'
      ],
      stats: [
        { num: '2.500+', label: 'Actieve boeren' },
        { num: '180K+', label: 'Geregistreerde dieren' },
        { num: '%98', label: 'Tevredenheid' }
      ]
    }
  },
  ru: {
    login: {
      title: 'Добро пожаловать',
      subtitle: 'Войдите в свой аккаунт',
      email: 'Адрес электронной почты',
      password: 'Пароль',
      forgotPassword: 'Забыли пароль',
      loginBtn: 'Войти →',
      loggingIn: 'Вход...',
      testAccount: 'Тестовый аккаунт (Фермер)',
      terms: 'Условия использования',
      privacy: 'Политика конфиденциальности',
      termsAccept: 'вы согласны с.',
      tryTestAccount: 'Попробуйте с тестовым аккаунтом',
      farm: 'Управляйте своей фермой разумно',
      description: 'Здоровье животных, отслеживание производства, финансовые отчеты и многое другое — все на одной платформе.',
      features: [
        'Отслеживание паспорта животного и родословной',
        'Медицинские записи и отслеживание вакцинации',
        'Отчеты о производстве в реальном времени',
        'Поддержка мобильного приложения'
      ],
      stats: [
        { num: '2.500+', label: 'Активные фермеры' },
        { num: '180K+', label: 'Зарегистрированные животные' },
        { num: '%98', label: 'Удовлетворение' }
      ]
    }
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

export function useTranslation() {
  const { language } = useLanguage();
  const translations = TRANSLATIONS[language] || TRANSLATIONS.tr;
  return (key) => {
    const keys = key.split('.');
    let result = translations;
    for (const k of keys) {
      result = result?.[k];
    }
    return result || key;
  };
}
